import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';

import { IFilterNumber } from '@shared/models/graphql';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setUnsavedSquareFootFiltersAction } from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-sqft',
  templateUrl: './filter-v2-sqft.component.html',
  styleUrls: [
    './filter-v2-sqft.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2SqftComponent implements OnInit {
  public minValue = 0;
  public maxValue = 0;
  protected options = [
    500, 750, 1000, 1250, 1500, 1750, 2000, 2250, 2500, 2750, 3000, 3500, 4000,
    5000, 7500,
  ];

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadInitialValue();

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (
          !filters?.squareFoot ||
          (!filters.squareFoot.greaterThanOrEqual &&
            !filters.squareFoot.lessThanOrEqual)
        ) {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }

  handleChange() {
    if (this.minValue > this.maxValue && this.maxValue > 0) {
      this.maxValue = this.minValue;
    }

    let squareFootQuery: IFilterNumber = {};
    if (this.minValue > 0) {
      squareFootQuery.greaterThanOrEqual = this.minValue;
    }
    if (this.maxValue > 0) {
      squareFootQuery.lessThanOrEqual = this.maxValue;
    }

    this.store.dispatch(setUnsavedSquareFootFiltersAction(squareFootQuery));
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.squareFoot) {
          if (filters.squareFoot.greaterThanOrEqual) {
            this.minValue = filters.squareFoot.greaterThanOrEqual;
          } else {
            this.minValue = 0;
          }
          if (filters.squareFoot.lessThanOrEqual) {
            this.maxValue = filters.squareFoot.lessThanOrEqual;
          } else {
            this.maxValue = 0;
          }
        } else {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }
}
